import { repository, adminURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(adminURL + '/admin/userGroup/findAll')
    return data
  },

  async create(body) {
    const { data } = await repository.post(adminURL + '/admin/userGroup', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(adminURL + '/admin/userGroup', body)
    return data
  },

  async remove(id) {
    return await repository.delete(adminURL + '/admin/userGroup/' + id)
  }
}
